import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Test Bestellung',
    ordered_at: 'Bestellt um:',
  },
  delivery_info: {
    info: 'Lieferanweisung:',
    note: 'Bemerkung:',
  },
  schedule_info: {
    pickup: 'Abholung',
    delivery: 'Lieferung',
    room_service_location: {
      room_service: 'Zimmer',
      table_service: 'Tisch',
    },
    wish_time: 'Gewünschte Zeit:',
    confirmed_time: 'Bestätigte Zeit:',
    driver_arrival_time: 'Fahrer Abholzeit:',
    external_delivery: 'Die Bestellung wird durch einen externen Fahrer von {{carrier}} ausgeliefert',
    order_instructions: 'Bestellanweisungen:',
  },
  products: {
    item: 'Artikel:',
  },
  discount_breakdown: {
    label: 'Rabatt',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '% Rabatt gesamt',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '% Rabatt Produkte',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Rabatt Produkte',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Rabatt gesamt',
    [OFFER_KIND.BOGO]: '2 für 1',
    [OFFER_KIND.BOGO_HALF_PRICE]: '2 für 1 (halb)',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis Produkt',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis gesamt',
    GiftCard: 'Geschenkkarte angewandt',
    Reward: 'Loyalty punkte angewandt',
    CashbackAccount: 'Loyalty punkte angewandt',
    PromoCodeComponent: 'Werbeaktion angewendet',
    Offer: 'Angebot angewendet',
  },
  payment_breakdown: {
    price: 'Preis:',
    subtotal: 'Zwischensumme',
    delivery_fee: 'Liefergebühr',
    tips: 'Trinkgeld',
    processing_fee: 'Onlinekostenzuschlag',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal Gebühr',
    },
    tax: 'Taxes',
    total: 'Gesamt',
    paid_amount: 'Gezahlter Betrag',
    order_not_paid: 'Bestellung wurde noch nicht bezahlt',
    order_paid_online: 'Bereits online bezahlt',
    cash: 'Bezahlung Vor Ort',
    this_is_not_an_invoice: 'Dies ist keine Rechnung',
  },
  delivery_qr_code: {
    scan: 'Scannen & Liefern mit Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
